module.exports = __webpack_public_path__ + "img/schedule_hover_2040402.webp";